import axios from 'axios';
import { attachApiErrorToastInterceptor } from './api-error-toast';

attachApiErrorToastInterceptor(axios);
